var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function TomTomIcon(props) {
    return (React.createElement("svg", __assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7505 30.0001L19.4873 23.5995H12.0137L15.7505 30.0001Z", fill: "#DF1B12" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7493 16.6812C12.9392 16.6812 10.6532 14.4202 10.6532 11.6414C10.6532 8.86244 12.9392 6.60151 15.7493 6.60151C18.5594 6.60151 20.8455 8.86244 20.8455 11.6414C20.8455 14.4202 18.5594 16.6812 15.7493 16.6812M15.7493 2C10.3735 2 6 6.32512 6 11.6414C6 16.9576 10.3735 21.2827 15.7493 21.2827C21.1251 21.2827 25.4987 16.9576 25.4987 11.6414C25.4987 6.32512 21.1251 2 15.7493 2", fill: "#DF1B12" })));
}
export default TomTomIcon;
//# sourceMappingURL=TomTomIcon.js.map